<template>
    <div class="d-flex flex-wrap tag-wrapper">
        <div class="tag" v-for="(e, i) in extraValue"><small>{{ e.short_name }}</small></div>
    </div>

</template>

<script>
export default {
    name: "OrganizationMunicipalityCell",
    props: {
        value: {},
        extraValue: {},
    },
    computed: {
        municipalities() {
            let parents = new Set();
            let municipalities = [];
            for (const m of this.extraValue) {
                if (m.parent && !parents.has(m.parent) || !m.parent) {
                    municipalities.push(m);
                }
                parents.add(m.parent)
            }
            return municipalities
        }
    }
}
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/functions";
    @import "node_modules/bootstrap/scss/variables";

    .tag {
        background-color: lighten($primary, 42%);
        border-radius: 12px;
        padding: 5px 10px;
        margin-right: 7px;
        margin-top: 5px
    }

    .tag-wrapper {
        margin-top: -5px
    }
</style>